import keyBy from 'lodash/keyBy';
import { actionTypes } from '../actions/paths';
import { paths as defaultState } from './default.json';
import { filterPath, getUpcomingCourses, getLesson } from '../lib/finder';

const handlers = {
  [actionTypes.PATH_GET_IN_PROGRESS]: state => ({
    ...state,
    inProgress: true,
  }),
  [actionTypes.PATH_GET_LIST_SUCCESS]: (state, action) => {
    const pathListByKeys = keyBy(action.results.items, obj => obj.slug);
    return {
      ...state,
      inProgress: false,
      results: pathListByKeys,
    };
  },
  [actionTypes.PATH_GET_BY_ID_SUCCESS]: (state, action) => ({
    ...state,
    inProgress: false,
    results: {
      ...state.results,
      [action.slug]: action.results,
    },
  }),
  [actionTypes.PATH_GET_BY_SLUG_SUCCESS]: (state, action) => ({
    ...state,
    inProgress: false,
    results: {
      ...state.results,
      [action.slug]: action.results,
    },
  }),
  [actionTypes.PATH_GET_ERROR]: (state, action) => ({
    ...state,
    inProgress: false,
    error: action.error,
  }),
  [actionTypes.PATH_SET_CURRENT]: (state, action) => {
    const { currentLesson, pathSlug, relatedLessons, playlistSlug, courseSlug } = action;
    const { path, playlist } = filterPath(state.results, pathSlug, playlistSlug);
    const { currentCourse, nextCourse } = getUpcomingCourses(
      state,
      pathSlug,
      playlistSlug,
      courseSlug,
    );
    let currentLessonID = null;
    if (
      !action.lessonSlug &&
      currentCourse &&
      Object.keys(action.myProgress).length &&
      action.myProgress.courses[currentCourse.id]
    ) {
      const courseProgress = action.myProgress.courses[currentCourse.id];
      currentLessonID = courseProgress.currentLesson;
    }
    const { nextLesson } = getLesson(currentCourse, action.lessonSlug, currentLessonID);
    return {
      ...state,
      watching: {
        ...state.watching,
        currentPath: path,
        currentPlaylist: playlist,
        currentCourse,
        nextCourse,
        relatedLessons,
        currentLesson,
        nextLesson,
      },
    };
  },
  [actionTypes.NEXT_LESSON_IN_COURSE_IN_PATH]: (state, action) => {
    const { currentLessonSlug } = action;
    const { currentLesson, nextLesson } = getLesson(
      state.watching.currentCourse,
      currentLessonSlug,
    );
    return {
      ...state,
      watching: {
        ...state.watching,
        currentLesson,
        nextLesson,
      },
    };
  },
  [actionTypes.CLEAR_WATCHING]: state => ({
    ...state,
    watching: {
      ...defaultState.watching,
    },
  }),
  [actionTypes.FC_SIGNOUT]: () => defaultState,
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
